/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import { useEffect, useRef } from "react";
import { Logger } from "cms/utils/log/logger";

/**
 * @param {string} id 
 * @param {boolean} shouldScroll 
 * @param {() => void=} onScroll
 */
const useScrollToContainer = (id, shouldScroll, onScroll) => {
    /** @type {import('react').MutableRefObject<HTMLDivElement | null>} */
    const ref = useRef(null);

    useEffect(() => {
        const container = ref.current;

        if (shouldScroll && container) {
            const wait = 250;
            Logger.info(`Scrolling to ${id} in ${wait}ms`, id, wait);

            setTimeout(() => {
                container.scrollIntoView({ behavior: "smooth" });
            }, wait);

            if (typeof onScroll === "function") {
                onScroll();
            }
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return ref;
};

export { useScrollToContainer };
